<template>
  <div>
    <div v-if="prePayOrder && prePayOrder.order_list">
      <div v-for="(currentOrder, index) in prePayOrder.order_list" :key="currentOrder.order_id">
        <!-- <AfterSalesDetail :order="currentOrder" :preOrderId="prePayOrder.prepay_id" type="preOrder" /> -->
        <div v-if="index == 0 && currentOrder" class="highlighted highlighted--total">
          <SfProperty :name="$t('Order_Status')" :value="$t(orderGetters.getStatus(currentOrder))"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('Total_price')" :value="$n(prePayOrder.amount, {
                        style: 'currency',
                        currency: currentOrder.trans_currency || '',
                    })" class="sf-property--full-width property" />
          <SfProperty :name="$t('order_shopping_firstname')" :value="getShippingMemberName(currentOrder)"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('MyAccount_MyShippingDetails_Phone')" :value="currentOrder.phone"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('Shipping_title')" :value="getShippingInfo(currentOrder)"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('payment_order_note')" :value="currentOrder.memberNote"
            class="sf-property--full-width property" />

          <SfProperty v-if="orderGetters.getStatus(currentOrder) == 'ORDER_WAIT_PAYMENT'" :name="$t('Pay_Order')"
            class="sf-property--full-width property">
            <template #value>
              <SfLink href="#" @click="orderGoPay()" link="">
                {{ $t('go_pay_order') }}
              </SfLink>
            </template>
          </SfProperty>
        </div>
        <SfTable class="products">
          <SfTableHeading>
            <SfTableHeader class="products__name">{{
              $t('Product')
              }}</SfTableHeader>
            <SfTableHeader>{{ $t('Quantity') }}</SfTableHeader>
            <SfTableHeader>{{ $t('OrderSku') }}</SfTableHeader>
            <!-- <SfTableHeader>{{ $t('Price') }}</SfTableHeader>
                    <SfTableHeader>{{ $t('Discount') }}</SfTableHeader>
                    <SfTableHeader>{{ $t('Total_price') }}</SfTableHeader> -->
          </SfTableHeading>
          <template v-for="(item, i) in currentOrder.order_item">
            <SfTableRow>
              <SfTableData class="products__name">
                <div style="display:flex;">
                  <nuxt-link :to="localePath('/p/' +
                                        item.good_id +
                                        '/' +  orderGetters.getItemName(item))">
                    <SfImage :src="(item.img_url)" :alt="item.title" class="orderImg" />
                  </nuxt-link>
                  <div>
                    <nuxt-link :to="localePath('/p/' +
                      item.good_id +
                      '/' +  orderGetters.getItemName(item))">
                      {{ orderGetters.getItemName(item) }}
                    </nuxt-link>
                  </div>
                </div>
              </SfTableData>
              <SfTableData>{{ orderGetters.getItemQty(item) }}</SfTableData>
              <SfTableData>
                <SfList>
                  <SfListItem v-for="(name, key) in getSkuInfo(item.sku_prop)" :key="key">
                    {{ key }}: {{ name }}
                  </SfListItem>
                </SfList>
              </SfTableData>
            </SfTableRow>
            <SfTableRow v-for="service_order in currentOrder.service_order" :key="service_order.service_order_id">
              <SfTableData class="products__name">
                {{ service_order.service_name }}
              </SfTableData>
              <SfTableData></SfTableData>
              <SfTableData>
                {{ $n(service_order.trans_amount, {
                style: 'currency',
                currency: service_order.trans_currency || '',
                }) }}
              </SfTableData>
            </SfTableRow>
          </template>
        </SfTable>
        <div style="padding:1rem 0;">
          <SfProperty :name="$t('shopName')" :value="(currentOrder.shop_name)"
            class="sf-property--full-width sf-property--large summary__property-total" />
          <SfProperty :name="$t('Order_No')" :value="(currentOrder.order_id)"
            class="sf-property--full-width sf-property--large summary__property-total" />
          <SfProperty :name="$t('payment_order_total')" :value="$n(currentOrder.payment, 'currency')"
            class="sf-property--full-width sf-property--large summary__property-total" />
          <SfProperty v-if="currentOrder.cfg && currentOrder.cfg.content" :name="$t('Offline_payment')"
            class="sf-property--full-width sf-property--large summary__property-total">
            <template #value>
              <div style="text-align: right" class="cnContent">
                <div v-html="currentOrder.cfg.content"></div>
              </div>
            </template>
          </SfProperty>
        </div>
        <SfDivider />
      </div>
    </div>
  </div>
</template>
<script>
import {
  SfTabs,
  SfTable,
  SfButton,
  SfProperty,
  SfLink,
  SfDivider,
  SfList,
  SfImage
} from '@storefront-ui/vue';
import { orderGetters, useCredential } from '@bee-hole/coms';
import AfterSalesDetail from '~/components/Order/AfterDetail';
import { useRouter } from '@nuxtjs/composition-api';
import orderItemGtter from '~/plugins/orderItemGtter.js';
export default {
  props: {
    prePayOrder: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'order'
    }
  },
  components: {
    SfTabs,
    SfTable,
    SfButton,
    SfProperty,
    SfLink,
    AfterSalesDetail,
    SfDivider,
    SfList,
    SfImage
  },
  setup(prop, { root }) {
    const { getPinJu, result: pingju } = useCredential();
    const router = useRouter();
    const orderGoPay = async () => {
      // previewOrderStore.setOrder(order);
      // router.push(root.localePath(`/xpay?orderNumber=${orderGetters.getId(order)}`));
      await getPinJu({ prepay_id: prop.prePayOrder?.prepay_id });
      if (pingju.value?.credential_id) {
        const transformedPath = `/xpay?orderNumber=${prop.prePayOrder?.prepay_id}&credential_id=${pingju.value?.credential_id}`;
        router.push(root.localePath(transformedPath));
      }
    };
    const getSkuInfo = (sku) => {
      if (sku && sku !== '') {
        return JSON.parse(sku);
      }
    };
    return {
      orderGetters,
      orderGoPay,
      ...(orderItemGtter),
      getSkuInfo
    };
  }
};
</script>
<style lang="scss" scoped>
.orderImg {
    width: 5rem;
    --_image-width: 5rem;
    margin:0;
    margin-right:1rem;
    .sf-image {
    width: 5rem;
    }
}
.highlighted {
    box-sizing: border-box;
    width: 100%;
    background-color: var(--c-light);
    padding: var(--spacer-sm);
    --property-value-font-size: var(--font-size--base);
    --property-name-font-size: var(--font-size--base);

    &:last-child {
        margin-bottom: 0;
    }

    ::v-deep .sf-property__name {
        white-space: nowrap;
    }

    ::v-deep .sf-property__value {
        text-align: right;
    }

    &--total {
        margin-bottom: var(--spacer-sm);
    }

    @include for-desktop {
        padding: var(--spacer-xl);
        --property-name-font-size: var(--font-size--lg);
        --property-name-font-weight: var(--font-weight--medium);
        --property-value-font-size: var(--font-size--lg);
        --property-value-font-weight: var(--font-weight--semibold);
    }
}

.AfterItem {
    margin-bottom: 20px;
}

</style>
<sylee lang="scss">
  .cnContent{
  max-width: 100%;
  white-space: normal !important; /* 强制换行 */
  overflow-wrap: break-word; /* 允许长单词换行 */
  word-break: break-all; /* 在*/
  div, p ,span{
    white-space: normal !important;
  }
}
</sylee>
